'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

export type Language = 'FR' | 'EN' | 'CN' | 'ZH' | 'JP' | 'IT' | 'ES' | 'KR' | 'AR' | 'PT';
type LanguageContextType = {
    lang: Language;
    setLang: (lang: Language) => void;
};

const LanguageContext = createContext<LanguageContextType>({ lang: 'FR', setLang: () => { } });

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
    const [lang, setLangState] = useState<Language>('FR');

    useEffect(() => {
        const stored = localStorage.getItem('OotentikLanguage') as Language;
        if (['FR','EN','CN','ZH','JP','IT','ES','KR','AR','PT'].includes(stored)) {
            setLangState(stored);
        }
    }, []);

    const setLang = (l: Language) => {
        setLangState(l);
        localStorage.setItem('OotentikLanguage', l);
    };

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
